import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { keyframes, styled } from 'styled-components';
import { border } from 'styled-system';
import { Box } from "../../../box/src";
import { ignoredProps, primaryShadow } from "../../../theme/src";
export const Scroll = forwardRef((_a, ref) => {
    var { $center, children } = _a, props = __rest(_a, ["$center", "children"]);
    return (_jsx(ScrollStyled, Object.assign({ "$center": $center }, props, { ref: ref, children: children })));
});
const ScrollStyled = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => ![...ignoredProps, 'property', 'theme'].includes(prop),
})
    .attrs(({ $center, bg, display = 'block', minHeight = 60, minWidth = 60, property = 'modal-top', theme, }) => (Object.assign(Object.assign({}, ($center
    ? {
        alignItems: 'center',
        justifyContent: 'center',
    }
    : {})), { bg: bg !== null && bg !== void 0 ? bg : theme.themeVariables.frameBackgroundColor, borderRadius: {
        _: 0,
        m: theme.themeVariables.globalBorderRadius,
    }, display, maxHeight: `calc(var(--viewport-height, 100vh) - var(--${property}))`, maxWidth: 'var(--viewport-width, 100vw)', minHeight: $center ? '100%' : minHeight, minWidth: $center ? '100%' : minWidth, mt: `var(--${property})`, overflowY: 'auto', position: 'relative' }))) `
  ${border}
  ${({ bg }) => bg !== 'transparent' && primaryShadow()}

  animation: 0.2s ${keyframes `0%{opacity:0}100%{opacity:1}`};
  transition: max-height 0.2s;
  -webkit-overflow-scrolling: touch;
`;
//# sourceMappingURL=Scroll.js.map